import React, { Component } from "react";
import { connect } from "react-redux";
import { injectIntl, defineMessages } from "react-intl";
import { bindActionCreators } from "redux";
import { List, Map, fromJS } from "immutable";
import { getFormValues, isValid, reset } from "redux-form";

import fileDownload from "js-file-download";

import { ExamHeader } from "components";

import * as examLib from "libs/examLib";

import * as examSummaryActions from "modules/examSummary";
import * as examListActions from "modules/examList";
import * as currentStatusActions from "modules/currentStatus";

class CtExamHeader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loadingVaccine: false,
      // loadingReport: false,
      // loadingReportMerge: false,
      // loadingReportCsv: false,
    };
  }

  onExamRefresh = () => {
    const { ExamSummaryActions, onGetExamList, examParam } = this.props;
    const params = {
      offset: 0,
      limit: examParam.get("limit"),
      refresh: true,
    };
    ExamSummaryActions.getExamSummary(params);
    onGetExamList(true);

    // 필터 초기화
    const { CurrentStatusActions, ExamListActions } = this.props;
    CurrentStatusActions.changeExamSummary({ name: "isInfection", value: false });
    ExamSummaryActions.changeParam({
      name: "filter",
      value: Map({}),
    });
    ExamListActions.changeExamListParam({
      name: "filter",
      value: Map({}),
    });
  };

  // // 보고서 다운로드
  // onDownloadExamReport = async () => {
  //   try {
  //     this.setState({ loadingReport: true });
  //     // 국제화 처리
  //     const { formatMessage } = this.props.intl;
  //     const { selectedExamSummaryNo, selectedExamList, examSummaryByExamNo } = this.props;

  //     if (selectedExamSummaryNo === 'all') {
  //       if (selectedExamList.size > 0) {
  //         // 보고서 여러개 받기
  //         for (let i = 0, l = selectedExamList.size; i < l; i++) {
  //           const respObj = await examLib.downloadExamReport({
  //             examNoArray: JSON.stringify([selectedExamList.get(i)])
  //           });
  //           if (respObj && respObj.status && respObj.status === 200 && respObj.data) {
  //             fileDownload(
  //               respObj.data,
  //               examSummaryByExamNo.getIn([String(selectedExamList.get(i)), 'examName']) +
  //               defineMessages(formatMessage({ id: 'CtExamHeader_1', defaultMessage: '_훈련_보고서.xlsx' }))
  //             );
  //           }
  //         }
  //       } else {
  //         return false;
  //       }
  //     } else {
  //       const respObj = await examLib.downloadExamReport({ examNoArray: JSON.stringify([selectedExamSummaryNo]) });
  //       if (respObj && respObj.status && respObj.status === 200 && respObj.data) {
  //         fileDownload(
  //           respObj.data,
  //           examSummaryByExamNo.getIn([String(selectedExamSummaryNo), 'examName']) +
  //           defineMessages(formatMessage({ id: 'CtExamHeader_1', defaultMessage: '_훈련_보고서.xlsx' }))
  //         );
  //       }
  //     }

  //     this.setState({ loadingReport: false });
  //   } catch (e) {
  //     console.log(e);
  //   }
  // };

  // // 통합 보고서 다운로드
  // onDownloadExamReportMerge = async () => {
  //   try {
  //     this.setState({ loadingReportMerge: true });
  //     // 국제화 처리
  //     const { formatMessage } = this.props.intl;
  //     const { selectedExamSummaryNo, selectedExamList, examSummaryByExamNo } = this.props;

  //     if (selectedExamSummaryNo === 'all' && selectedExamList.size > 1) {
  //       // 통합 보고서 다운로드
  //       if (true) {
  //         const isValidExamNo = {};
  //         for (let i = 0, l = selectedExamList.size; i < l; i++) {
  //           const pNo = examSummaryByExamNo.get(String(selectedExamList.get(i))).get('parentsExamNo');
  //           if (pNo) {
  //             if (typeof isValidExamNo[pNo] === 'undefined') {
  //               isValidExamNo[pNo] = 0;
  //             }

  //             isValidExamNo[pNo] += 1;
  //           } else {
  //             break;
  //           }
  //         }

  //         if (
  //           isValidExamNo &&
  //           // 한개의 parentsExamNo만 있어야 한다.
  //           Object.keys(isValidExamNo).length === 1 &&
  //           // 모든 parentsExamNo의 개수가 선택한 훈련의 수와 같아야 한다.
  //           isValidExamNo[Object.keys(isValidExamNo)[0]] === selectedExamList.size
  //         ) {
  //           const respObj = await examLib.downloadExamReport({ examNoArray: JSON.stringify(selectedExamList) });
  //           if (respObj && respObj.status && respObj.status === 200 && respObj.data) {
  //             fileDownload(
  //               respObj.data,
  //               examSummaryByExamNo.getIn([String(Object.keys(isValidExamNo)[0]), 'examName']) +
  //               defineMessages(formatMessage({ id: 'CtExamHeader_1', defaultMessage: '_훈련_보고서.xlsx' }))
  //             );
  //           }
  //         } else {
  //           alert('보고서 다운 실패');
  //         }
  //       }
  //     }

  //     this.setState({ loadingReportMerge: false });
  //   } catch (e) {
  //     console.log(e);
  //   }
  // };

  // // CSV 보고서 다운로드
  // onDownloadExamReportCsv = async () => {
  //   try {

  //     this.setState({ loadingReportCsv: true });
  //     // 국제화 처리
  //     const { formatMessage } = this.props.intl;
  //     const { selectedExamSummaryNo, selectedExamList, examSummaryByExamNo } = this.props;
  //     if (selectedExamSummaryNo === 'all' && selectedExamList.size > 0) {
  //       // 통합 보고서 다운로드
  //       if (true) {
  //         const respObj = await examLib.downloadExamReport({ examNoArray: JSON.stringify(selectedExamList), csv: 1});
  //         if (respObj && respObj.status && respObj.status === 200 && respObj.data) {
  //           fileDownload(
  //             respObj.data,
  //             defineMessages(formatMessage({ id: 'CtExamHeader_2', defaultMessage: '훈련_보고서.xlsx' }))
  //           );
  //         } else {
  //           alert('보고서 다운 실패');
  //         }
  //       }
  //     } else {
  //       const respObj = await examLib.downloadExamReport({ examNoArray: JSON.stringify([selectedExamSummaryNo]), csv: 1});
  //       if (respObj && respObj.status && respObj.status === 200 && respObj.data) {
  //         fileDownload(
  //           respObj.data,
  //           examSummaryByExamNo.getIn([String(selectedExamSummaryNo), 'examName']) +
  //           defineMessages(formatMessage({ id: 'CtExamHeader_2', defaultMessage: '훈련_보고서.xlsx' }))
  //         );
  //       }
  //     }

  //     this.setState({ loadingReportCsv: false });
  //   } catch (e) {
  //     console.log(e);
  //   }
  // };

  // 모달 처리
  onToggleModal = (viewType) => {
    // (태그 추가 모달) 초기화
    const { CurrentStatusActions } = this.props;

    CurrentStatusActions.onToggleModal({ viewType: viewType });
  };

  // 백신 모달
  onActionVaccine = async (type) => {
    // 백신 다운로드
    if (type === "down") {
      const respObj = await examLib.downloadVaccine();
      if (respObj && respObj.status && respObj.status === 200 && respObj.data) {
        fileDownload(respObj.data, "MudfixVaccine.exe");
      }
    } else if (type === "send") {
      this.setState({ loadingVaccine: true });

      const { selectedExamSummaryNo, path, examListFilter } = this.props;
      const params = {
        examNo: selectedExamSummaryNo,
      };

      if (path.get("current") === "/main/exam/pi") {
        params["filter"] = examListFilter.toJS();
        params["subTab"] = "pi";
      }

      const respObj = await examLib.sendVaccine(params);
      if (respObj && respObj.status && respObj.status === 200 && respObj.data) {
        this.onToggleModal("");
      }

      this.setState({ loadingVaccine: false });
    } else if (type === "infectionSend") {
      this.setState({ loadingVaccine: true });

      const { selectedExamSummaryNo, path, examListFilter } = this.props;
      const params = {
        examNo: selectedExamSummaryNo,
      };

      if (path.get("current") === "/main/exam/pi") {
        params["filter"] = examListFilter.toJS();
        params["subTab"] = "pi";
        params["infectionTarget"] = 1;
      }

      const respObj = await examLib.sendVaccine(params);
      if (respObj && respObj.status && respObj.status === 200 && respObj.data) {
        this.onToggleModal("");
      }

      this.setState({ loadingVaccine: false });
    }
  };

  render() {
    const { isModal, examSummaryByExamNo, examSummaryOrdering, selectedExamSummaryNo, selectedExamList, examListTotalItem, path } = this.props;
    const { onExamRefresh, onDownloadExamReport, onDownloadExamReportMerge, onDownloadExamReportCsv, onActionVaccine, onToggleModal } = this;

    return (
      <ExamHeader
        currentPath={path.get("current")}
        isModal={isModal}
        loadingVaccine={this.state.loadingVaccine}
        // loadingReport={this.state.loadingReport}
        // loadingReportMerge={this.state.loadingReportMerge}
        // loadingReportCsv={this.state.loadingReportCsv}
        examSummaryByExamNo={examSummaryByExamNo}
        examSummaryOrdering={examSummaryOrdering}
        selectedExamSummaryNo={selectedExamSummaryNo}
        selectedExamList={selectedExamList}
        examListTotalItem={examListTotalItem}
        // function
        onExamRefresh={onExamRefresh}
        onDownloadExamReport={onDownloadExamReport}
        onDownloadExamReportMerge={onDownloadExamReportMerge}
        onDownloadExamReportCsv={onDownloadExamReportCsv}
        onActionVaccine={onActionVaccine}
        onToggleModal={onToggleModal}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  isModal: state.currentStatus.get("isModal"),
  path: state.currentStatus.get("path"),
  selectedExamSummaryNo: state.currentStatus.getIn(["examSummary", "selected"]),
  selectedExamList: state.currentStatus.getIn(["examList", "selected", "noArray"]),
  examSummaryByExamNo: state.examSummary.get("examSummaryByExamNo"),
  examSummaryOrdering: state.examSummary.get("examSummaryOrdering"),
  totalCount: state.examSummary.get("totalCount"),
  examParam: state.examSummary.get("param"),
  examListTotalItem: state.examList.get("totalItem"),
  examListFilter: state.examList.getIn(["param", "filter"]),
});

const mapDispatchToProps = (dispatch) => ({
  ExamSummaryActions: bindActionCreators(examSummaryActions, dispatch),
  ExamListActions: bindActionCreators(examListActions, dispatch),
  CurrentStatusActions: bindActionCreators(currentStatusActions, dispatch),
  ReduxFormReset: bindActionCreators(reset, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CtExamHeader));



// WEBPACK FOOTER //
// ./src/script/containers/exam/CtExamHeader.js